import * as React from 'react';
import {BlockType, EstimateType, TaskObject} from 'api/task/types';
import {Builder} from 'components/Builder';
import {Content, Settings} from './components';
import Tabbar from 'components/Tabbar';
import Tab from 'components/Tab';
import {TaskBuilderProps} from './types';

/**
 * The task builder component.
 * @param {TaskBuilderProps} props
 * @return {React.ReactElement<TaskBuilderProps>}
 * @constructor
 */
export default function TaskBuilder(
    props: TaskBuilderProps,
): React.ReactElement<TaskBuilderProps> {
  const defaultTask: Partial<TaskObject> = {
    preview: null,
    settings: {
      estimate: {
        type: EstimateType.Five,
        points: [0, 0, 0, 0, 0],
      },
    },
    content: {
      blocks: [],
    },
  };

  return (
    <Builder<TaskObject> {...props} defaultValue={defaultTask}>
      {{
        header: () => (
          <Builder.Header>
            {{
              content: (
                <React.Fragment>
                  <Builder.Header.Title placeholder="Введите название задания" />
                  <Builder.Header.Description placeholder="Введите описание задания" />
                </React.Fragment>
              )
            }}
          </Builder.Header>
        ),
        content: (
          <Tabbar>
            <Tab name="content" title="Содержание">
              <Content />
            </Tab>
            <Tab name="settings" title="Настройки">
              <Settings />
            </Tab>
          </Tabbar>
        ),
        footer: (options) => (
          <Builder.Footer {...options} />
        )
      }}
    </Builder>
  );
}
